import { APP_KEY_IDS } from "../../../constants/constants";
import Styles from "./AppPanel.module.scss";
import classnames from "classnames"

//Redux
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { openWindow } from "../../../actions";
import handleTaskView from "../../../reducers/taskView";

export const MOBILE_APPS = [
    {
        id: APP_KEY_IDS.MOBILE_MUSIC,
        label: "Samsung Music",
        description: "Samsung Music app for listening to music.",
    },
    {
        id: APP_KEY_IDS.MOBILE_DEV_SKILLS,
        label: "Development Skills",
        description: "This app shows the skills I have in development.",
    },
    {
        id: APP_KEY_IDS.MOBILE_SPOTIFY,
        label: "Spotify",
        description: "Basic Information about me is present in this.",
    },
    {
        id: APP_KEY_IDS.MOBILE_FILE_MANAGER,
        label: "File Manager",
        description: "File manager contains some documents related to my professional requirements.",
    },
    {
        id: "mobile skip 2",
        label: "",
        description: "",
    },
    {
        id: APP_KEY_IDS.MOBILE_BIXBY,
        label: "About Me",
        description: "Basic Information about me is present in this.",
    },
    {
        id: APP_KEY_IDS.MOBILE_GALAXY_STORE,
        label: "Galaxy Store",
        description: "It contains all the apps I have developed till date.",
    },
    {
        id: APP_KEY_IDS.MOBILE_BROWSER,
        label: "Samsung Internet",
        description: "This is a browser.",
    },
    {
        id: APP_KEY_IDS.MOBILE_SETTINGS,
        label: "Settings",
        description: "This contains setting for this website. You can tweak the UI here.",
    },
    {
        id: APP_KEY_IDS.MOBILE_MAIL,
        label: "Email",
        description: "Open Email",
        onClick: () => { window.open('https://mail.google.com/mail/#inbox') }
    },
    {
        id: APP_KEY_IDS.MOBILE_PHONE,
        label: "Phone",
        description: "This is a chatting app. I can be contacted here via chatting.",
    },
    {
        id: APP_KEY_IDS.MOBILE_CAMERA,
        label: "Camera",
        description: "This is a camera app.",
    },
    {
        id: APP_KEY_IDS.MOBILE_GALLERY,
        label: "Gallery",
        description: "It contains pictures.",
    },
    {
        id: APP_KEY_IDS.MOBILE_MESSAGES,
        label: "Messages",
        description: "This is a chatting app. I can be contacted here via chatting.",
    },
    {
        id: APP_KEY_IDS.MOBILE_CONTACTS,
        label: "Contacts",
        description: "This app shows my details and contact information.",
    }
]


interface AppPanelProps {
    customCLass?: string
}

const AppPanel = ({ customCLass }: AppPanelProps) => {
    const dispatch = useDispatch()
    const isTaskViewEnabled = useSelector((state: RootStateOrAny) => state.handleTaskView)


    return (
        <div className={classnames(Styles.container, customCLass && customCLass)}>
            {!isTaskViewEnabled &&

                <>
                    <div className={Styles.top_half}>
                        {MOBILE_APPS.slice(0, 10).map((app) => {
                            return (
                                <div className={Styles.app_container} key={app.id} onClick={app.onClick ? app.onClick : () => { dispatch(openWindow(app.id)) }}>
                                    <div className={Styles.app_icon} id={app.id} ></div>
                                    <div className={Styles.app_label}>{app.label}</div>
                                </div>
                            )
                        })}
                    </div>
                    <div className={Styles.divider}>
                        <div className={Styles.spot}></div>
                    </div>
                </>
            }
            <div className={Styles.top_half} style={{ padding: "8px 0" }}>
                {MOBILE_APPS.slice(10, 15).map((app) => {
                    return (
                        <div className={Styles.app_container} key={app.id} onClick={app.onClick ? app.onClick : () => { dispatch(openWindow(app.id)) }} >
                            <div className={Styles.app_icon} id={app.id} ></div>
                            <div className={Styles.app_label}>{app.label}</div>
                        </div>
                    )
                })}

            </div>
        </div>
    )
}

export default AppPanel
